// extracted by mini-css-extract-plugin
export default {"document":"CustomerGrin4UInfo_document__ruYma","documentInput":"CustomerGrin4UInfo_documentInput__9i2JH","documentContent":"CustomerGrin4UInfo_documentContent__cvLqR"};